import { breakpoints } from '../design-tokens/breakpoints';

type BreakpointKey = keyof typeof breakpoints;

export const media = {
  up: (key: BreakpointKey) => `@media (min-width: ${breakpoints[key]})`,
  down: (key: BreakpointKey) => {
    const value = parseInt(breakpoints[key], 10);
    return `@media (max-width: ${value - 1}px)`;
  },
};

export { breakpoints };
